module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921104149_T.7d5f4501.jpg";